import script from "./fenpei.vue?vue&type=script&setup=true&lang=ts"
export * from "./fenpei.vue?vue&type=script&setup=true&lang=ts"

import "./fenpei.vue?vue&type=style&index=0&id=efdeecc4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efdeecc4"]])

export default __exports__